import React from 'react'
import { Popover as UIPopover } from '@headlessui/react'
import { useRouter } from 'next/router'
import { Text, Button } from '@/components/common'
import { useExperiment } from '@/experimentation'
import SegmentHandler from '@/services/analytics/SegmentHandler'
import useAuth from '@/services/hooks/useAuth'

export interface Props {
  className?: string
}

const UserMenuLoggedOut: React.FC<Props> = ({ className }) => {
  const { startAuth, openModal } = useAuth()
  const router = useRouter()
  const [isOAuth2] = useExperiment('ellis_island_oauth2', true)

  return (
    <div className={className}>
      <UIPopover.Button as="div">
        <Button
          size="sm"
          className="w-[150px]"
          onClick={() => {
            if (isOAuth2) {
              startAuth()
            } else {
              openModal('login')
            }

            SegmentHandler.track('On Tap', {
              location: router.asPath,
              section_name: 'header',
              element_name: 'menu_item',
              value: 'Login',
              action_type: 'tap',
            })
          }}
        >
          <Text as="span" preset="body.md">
            Log In
          </Text>
        </Button>
      </UIPopover.Button>

      <UIPopover.Button as="div">
        <Button
          variant="secondary"
          size="sm"
          className="mt-2 w-full"
          onClick={() => {
            if (isOAuth2) {
              startAuth()
            } else {
              openModal('register')
            }
            SegmentHandler.track('On Tap', {
              location: router.asPath,
              section_name: 'header',
              element_name: 'menu_item',
              value: 'Sign Up',
              action_type: 'tap',
            })
          }}
        >
          <Text as="span" preset="body.md">
            Sign Up
          </Text>
        </Button>
      </UIPopover.Button>
    </div>
  )
}

export default UserMenuLoggedOut
